import React from 'react';
import './ProductManagement.scss';
import classNames from 'classnames';
import ProductManagementTab from './ProductManagementTab';
import SalesRecords from './SalesRecords';
import SalesRanking from './SalesRanking';
import ProductSettings from './ProductSettings';

class ProductManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
  }

  handleTabChange = (tabIndex) => {
    this.setState({ activeTab: tabIndex });
  }

  render() {
    const { activeTab } = this.state;

    return (
      <section className="product-management">
        <section className="product-management-list">
          <section className="GameList__wrapper">
            <section>
              <ul className="GameList__items">
                <li
                  className={classNames('GameList__GameItem', {
                    active: activeTab === 0,
                  })}
                  onClick={() => this.handleTabChange(0)}
                >
                  Product Management
                </li>
              </ul>
              <ul className="GameList__items">
                <li
                  className={classNames('GameList__GameItem', {
                    active: activeTab === 1,
                  })}
                  onClick={() => this.handleTabChange(1)}
                >
                  Sales Records
                </li>
              </ul>
              <ul className="GameList__items">
                <li
                  className={classNames('GameList__GameItem', {
                    active: activeTab === 2,
                  })}
                  onClick={() => this.handleTabChange(2)}
                >
                  Sales Ranking
                </li>
              </ul>
              <ul className="GameList__items">
                <li
                  className={classNames('GameList__GameItem', {
                    active: activeTab === 3,
                  })}
                  onClick={() => this.handleTabChange(3)}
                >
                  Setting
                </li>
              </ul>
            </section>
          </section>
        </section>

        <section className="product-management-container">
          <div className="tab-content">
            {activeTab === 0 && <ProductManagementTab {...this.props} />}
            {activeTab === 1 && <SalesRecords {...this.props} />}
            {activeTab === 2 && <SalesRanking {...this.props} />}
            {activeTab === 3 && <ProductSettings {...this.props} />}
          </div>
        </section>
      </section>
    );
  }
}

export default ProductManagement;
